module.exports = __webpack_public_path__ + "img/logo.d93b540b.svg";